import {useState, useEffect, useRef}  from 'react';
import APanel from './APanel';
import CoverPage from '../CoverPage';
import NavBar from './NavBar';
import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as HolderWrapperFn from '../ContentItems/HolderWrapperFn';
import * as SizeFunctions from '../utilities/SizeFunctions';

function App(props) {

  var actualWidth = props.actualWidth;
  var insetWidth = props.insetWidth;
  var overallWidth = props.overallWidth;
  var scale = props.scale;
  var insetHeight = props.insetHeight;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var whichFEOrPU = props.whichFEOrPU;
  var onClickItemChangeSelection = props.onClickItemChangeSelection;
  var internalVariables = props.internalVariables;
  var refObject = props.refObject;
  var getRef1 = props.getRef1;
  var userNos = props.userNos;
  var userID = props.userID;
  var counter = props.counter;

  var otherPeoplesPositions = props.otherPeoplesPositions;
  var updatesToPropagate = props.updatesToPropagate;
  var error = props.error;
  var inputValues = props.inputValues;
  var setInputValues = props.setInputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var alertVisibility = props.alertVisibility;
  var interactionFn = props.interactionFn;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var screenRefs = props.screenRefs;
  var setScreenRefs = props.setScreenRefs;
  var addWhereText = props.addWhereText;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var changeTab = props.changeTab;
  var tabSelected = props.tabSelected;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var flashHighlight = props.flashHighlight;
  var reportPageHeight = props.reportPageHeight;
  var offsetTop = props.offsetTop;
  var offsetLeft = props.offsetLeft;
  var chains = props.chains;
  var lastEdited = props.lastEdited;

  var navRef = useRef();
  var pageRef = useRef();
  var pageRef4 = useRef();

  var whichFE = whichFEOrPU.v;
  var feOrPU = whichFEOrPU.t;

  var thisPage = feOrPU + '_' + whichFE;
  var thisPageBlankString = feOrPU + ' ' + whichFE;

  var screens = CoreFns.goDownPath(currentList, [feOrPU, whichFE, '_s']);
  var screenKeys = CoreFns.sortedKeyList(screens);
  const [hoveringWhere, setHoveringWhere] = useState('');

  function doAScreenRef(ref, panelPath){
    screenRefs[panelPath.join('_')] = ref;
    setScreenRefs({...screenRefs})      
  }

    useEffect(() => {
      const scrollElements = document.querySelectorAll('.jsScroll');

      const elementInView = (el, dividend = 1) => {
        const elementTop = el.getBoundingClientRect().top;
        // console.log(elementTop);
        // console.log(insetHeight);
        // // console.log(pageRef4.current.offsetTop);
        // console.log(pageRef4.current.scrollTop);

        return (
          elementTop <= (insetHeight / dividend)
          // (window.innerHeight || document.documentElement.clientHeight) / dividend
        );
      };

      const elementOutofView = (el, dividend = 1) => {
        const elementTop = el.getBoundingClientRect().top;

        return (
          elementTop > (insetHeight / dividend)
          // elementTop > (window.innerHeight || document.documentElement.clientHeight)
        );
      };

      const displayScrollElement = (element) => {
        element.classList.add('scrolled');
      };

      const hideScrollElement = (element) => {
        element.classList.remove('scrolled');
      };

      const handleScrollAnimation = () => {
        scrollElements.forEach((el) => {
          if (elementInView(el, 1)) {
            displayScrollElement(el);
          } else if (elementOutofView(el, 1)) {
            hideScrollElement(el);
          }
        });
      };

      if (pageRef4 && pageRef4.current && interactionFn){
        pageRef4.current.addEventListener('scroll', handleScrollAnimation);
      }

      return () => {
        if (pageRef4 && pageRef4.current && interactionFn){
          pageRef4.current.removeEventListener('scroll', handleScrollAnimation);
        }
      };
    }, []);

  useEffect(() => {
    if (navRef){
      var pp = [feOrPU, whichFE, 'nv'];
      screenRefs[pp.join('_')] = navRef;
      setScreenRefs({...screenRefs})      
    }
  }, [whichFE, feOrPU]); 

  function actHoveringWhere(x){
    return function(e){
      setHoveringWhere(x);
      e.stopPropagation();
    }
  }
  var style = props.style;

  StyleFunctions.modStyleWithFlashHighlight(style, flashHighlight, thisPageBlankString);

  var className = props.className;
  var bottomBit = props.bottomBit;


  var overallS = StyleFunctions.dappBaselineStyle(currentList, internalVariables, insetWidth, insetHeight, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);

  var cellStyle = {width:actualWidth};

  function addPiece(name){
    return <div key={name} style={cellStyle}><center><p className='lead mb-0'>Click and {name} will be added here</p></center></div>
  }
//
  var navBarPath = [whichFEOrPU.t, whichFEOrPU.v, 'nv'];
  var navPart;
  var navInfo = CoreFns.goDownPath(currentList, navBarPath);


//  
  if (navInfo && navInfo.on){

    var navBarPathAct;
    var gotErrorHere = false;

    if (navInfo.on === 1){
      navBarPathAct = navBarPath; 
    }else{
      try{
        navBarPathAct = ['cn', navInfo.on, 'nv'];
        navInfo = CoreFns.goDownPath(currentList, navBarPathAct);        
      }catch(err){
        gotErrorHere = true;
      }
    }

    if (gotErrorHere){
    }else{
      var editingClass = '';
      if (!interactionFn){
        if (itemEdited && itemEdited.t === 'navBar'){
          editingClass = ' editing';
        }else if (hoveringWhere ==='navBar'){
          editingClass = ' preEditing';
        }
      }

      cellStyle.zIndex = 30;
      function clickHighlightBar(e){
        if (setItemEdited){
          setItemEdited({t:'navBar', path:navBarPath});
        }
        e.stopPropagation();
      }
      if (navInfo.s.navbarSticky){
        cellStyle.position = 'sticky';
        cellStyle.top = 0;      
      }


      cellStyle.textAlign = 'left';
      navPart = <div ref={navRef} onClick={clickHighlightBar} style={{...overallS, ...cellStyle}} className={editingClass} onMouseOver={actHoveringWhere('navBar')} onMouseOut={actHoveringWhere('')}><NavBar organicChanges={organicChanges} chains={chains} currentList={currentList} internalVariables={internalVariables} width={insetWidth} height={insetHeight} inputValues={inputValues} ownVariables={ownVariables} navBarPath={navBarPathAct} navBarPathOrig={navBarPath} itemEdited={itemEdited} setItemEdited={setItemEdited} interactionFn={interactionFn} error={error} actHoveringWhere={actHoveringWhere} hoveringWhere={hoveringWhere} changeTab={changeTab} tabSelected={tabSelected} isShowingSomeDropDown={isShowingSomeDropDown} flashHighlight={flashHighlight} doAScreenRef={doAScreenRef} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader}/></div>

    }

//
  }else if (potentiallyAddWhichItem && potentiallyAddWhichItem.t === 'Nav Bar'){
    navPart = addPiece('Navigation Bar');
  }
//

//
//
  style.lineHeight = 'normal';
  style.fontSize = '1em';

  function doAPageRef(ref){
    screenRefs[thisPage] = ref;
    setScreenRefs({...screenRefs});
  }

  useEffect(()=>{
    doAPageRef(pageRef);
  }, [thisPage]); 

  function doPanel(panelPath){

    var relativeSize = insetWidth * scale / overallWidth;

    return <APanel chains={chains} relativeSize={relativeSize} actualWidth={actualWidth} panelPath={panelPath} style={overallS} inputValues={inputValues} setInputValues={setInputValues} alertVisibility={alertVisibility} insetWidth={insetWidth} currentList={currentList} organicChanges={organicChanges} userNos={userNos} userID={userID} itemEdited={itemEdited} setItemEdited={setItemEdited} onClickItemChangeSelection={onClickItemChangeSelection} internalVariables={internalVariables} refObject={refObject} getRef1={getRef1} otherPeoplesPositions={otherPeoplesPositions} updatesToPropagate={updatesToPropagate} error={error} insetHeight={insetHeight} interactionFn={interactionFn} setIsShowingSomeDropDown={setIsShowingSomeDropDown} isShowingSomeDropDown={isShowingSomeDropDown} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} doAScreenRef={doAScreenRef} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} actHoveringWhere={actHoveringWhere} hoveringWhere={hoveringWhere} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} hidePanelRelativeItems={hidePanelRelativeItems} flashHighlight={flashHighlight} changeTab={changeTab} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} offsetLeft={offsetLeft} offsetTop={offsetTop} lastEdited={lastEdited} counter={counter}/>
  }

  var detIn = screenKeys.map((aScreenKey, index)=>{
    var panelPath = [whichFEOrPU.t, whichFEOrPU.v, '_s', aScreenKey];
    return doPanel(panelPath);
  })  

  var det;
  if (itemEdited && itemEdited.t === 'screen'){
    det = HolderWrapperFn.doActualWrap(screenKeys, [whichFEOrPU.t, whichFEOrPU.v], '_s', itemEdited, setItemEdited, currentList, organicChanges, 'screen', detIn, actualWidth)
  }else{
    det = detIn;
  }



  if (potentiallyAddWhichItem && potentiallyAddWhichItem.t === 'PANEL'){
    det.push(addPiece('Panel'))    
  }
//  

  var footerPart;
  if (whichFEOrPU.t === 'fe'){
    if (currentList.fo && currentList.fo.on){
      footerPart = doPanel(['fo']);
    }else if (potentiallyAddWhichItem && potentiallyAddWhichItem.t === 'FOOTER'){
      footerPart = addPiece('Footer')
    }
  }

  function onMouseDown(e){
    e.stopPropagation();
  }
  var inside = <center>{navPart}{det}{bottomBit}{footerPart}</center>
//
  if (reportPageHeight){
    inside = <CoverPage contents={inside} reportHeight={SizeFunctions.updateSubsetDimensions(reportPageHeight)} />
  }

  return <div className={className} style={style} onMouseDown={onMouseDown} ref={pageRef4}><div ref={pageRef}></div>{inside}</div>
//  
}

export default App;
